import { IconButton, MenuItem } from "@mui/material";
import { MAX_YEARS, MONTHS } from "../../consts/strings";
import { memo, useEffect, useState } from "react";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import StyledSelect from "../StyledSelect";
import { View } from "../View";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { palette } from "../../theme/palette";
import { range } from "lodash";

const useStyles = makeStyles({
  container: {
    background: "transparent",
    display: "flex",
    justifyContent: "space-between",
  },
  buttons: {
    display: "flex",
    "& button": {
      padding: 0,
    },
  },
  icon: {
    cursor: "pointer",
  },
  select: {
    textAlign: "left",
    color: palette.typography.black.medium,
    "& *": {
      color: palette.typography.black.medium,
    },
  },
});

export const DatePickerHeader = memo(
  ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    pastDates = false,
  }) => {
    const [currentDate] = useState(moment.utc());
    const [selected, setSelected] = useState(moment.utc().format("MMMM YYYY"));
    const [monthYear, setMonthYear] = useState([]);
    const styles = useStyles();

    useEffect(() => {
      setSelected(moment.utc(date).format("MMMM YYYY"));
    }, [date]);

    useEffect(() => {
      const temp = [];
      range(0, MAX_YEARS * 12).forEach((monthIndex) => {
        let monthDate = currentDate
          .clone()
          .add(monthIndex * (pastDates ? -1 : 1), "months");
        temp.push(`${monthDate.format("MMMM")} ${monthDate.format("YYYY")}`);
      });
      setMonthYear(temp);
    }, [currentDate, pastDates]);

    const handleChange = (event) => {
      setSelected(event.target.value);
      const [month, year] = event.target.value.split(" ");
      changeMonth(MONTHS[month]);
      changeYear(year);
    };

    const selectedDate = moment.utc(selected);

    const isDateAvailable = (date) => {
      return (
        monthYear.indexOf(`${date.format("MMMM")} ${date.format("YYYY")}`) > -1
      );
    };
    return (
      <View className={styles.container}>
        <View>
          <StyledSelect
            value={selected}
            className={styles.select}
            disableUnderline
            onChange={handleChange}
          >
            {Array.isArray(monthYear) &&
              monthYear.map((value) => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
          </StyledSelect>
        </View>
        <View className={styles.buttons}>
          <IconButton
            onClick={decreaseMonth}
            disabled={!isDateAvailable(selectedDate.clone().add(-1, "months"))}
            size="large"
          >
            <ChevronLeftIcon className={styles.icon} />
          </IconButton>
          <IconButton
            onClick={increaseMonth}
            disabled={!isDateAvailable(selectedDate.clone().add(1, "months"))}
            size="large"
          >
            <ChevronRightIcon className={styles.icon} />
          </IconButton>
        </View>
      </View>
    );
  }
);
